var checkProgress = function (global) {
    var answers = global.response.answers;
    // var answered = 0;
    // _(answers).each(function(ans) {
    //     if (typeof ans.answer !== 'undefined' && ans.answer !== null && ans.answer > 0) {
    //         answered++;
    //     }
    //
    // });

    var total = answers.length;

    var percentage = Math.floor((global.questionIndex+1)/total * 100);
    // var percentage = Math.floor(answered/total *100);

    var progressBar = $('.progress .progress-bar');
    $(progressBar).attr('aria-valuenow',percentage);
    $(progressBar).css('width',percentage + '%');
    $(progressBar).html(percentage + '%');



}
module.exports = checkProgress;


//////////////////
// WEBPACK FOOTER
// ./src/checkprogress.js
// module id = 48
// module chunks = 0